export default __webpack_public_path__ + "static/media/connectivity-mobile.1da123f6.jpg";